import React from 'react';
import { isMobile, roundInfoStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../store/gameStore';

export const RoundTimer = observer(() => {
  const { time, reportResult } = gameStore;
  const { duration } = roundInfoStore;
  // const [animationDelay, setAnimationDelay] = useState(null);
  const radius = 14.5;
  const circumference = 2 * Math.PI * radius;
  // const animationDuration = duration / (reportResult.length ? 2 : 1);

  // useEffect(() => {
  //   if (!animationDelay && animationDelay !== 0) {
  //     setAnimationDelay(animationDuration - time);
  //   }
  //
  //   if (!time) {
  //     setAnimationDelay(0);
  //   }
  // }, [animationDelay, time, animationDuration]);

  return time || time === 0 ? (
    <div className='c-m-time-svg blue'>
      <svg
        className='circle-chart'
        height='100%'
        viewBox='1 1 32 32'
        width='100%'
        xmlns='http://www.w3.org/2000/svg'
      >
        <defs>
          <linearGradient id='gradient'>
            <stop
              offset='0%'
              className='start-g-color'
              style={{ stopColor: 'rgba(31, 60, 114, 0.4)' }}
            />
            <stop offset='100%' style={{ stopColor: 'rgb(31, 60, 114)' }} />
          </linearGradient>
        </defs>
        <circle
          className='circle-chart__background'
          cx='16.91549431'
          cy='16.91549431'
          r='14.5'
          stroke='none'
          strokeOpacity='1'
          strokeWidth='3'
        />
        <circle
          className='round-loader circle-chart__circle'
          cx='16.91549431'
          cy='16.91549431'
          fill='none'
          r='14.5'
          strokeWidth='2.4'
          strokeDasharray={circumference}
          strokeDashoffset={
            isMobile()
              ? circumference * (time / (duration / (reportResult.length ? 2 : 1)))
              : -(
                  circumference -
                  circumference * (time / (duration / (reportResult.length ? 2 : 1)))
                )
          }
          // style={{
          //   animationDuration: `${animationDuration}s`,
          //   animationDelay: `${animationDelay}s`,
          // }}
        />
      </svg>
      <span className='c-m-time-svg-txt'>{time}</span>
    </div>
  ) : null;
});
